import { render, staticRenderFns } from "./MilestonesList.vue?vue&type=template&id=0fb39eb8"
import script from "./MilestonesList.vue?vue&type=script&lang=js"
export * from "./MilestonesList.vue?vue&type=script&lang=js"
import style0 from "./MilestonesList.vue?vue&type=style&index=0&id=0fb39eb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports